export default __webpack_public_path__ + "static/media/icon_loading.23d67691.png";